var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Switch from '../../_lib/component/Switch';
import ToggleContext from './ToggleContext';
function ToggleButton(props) {
    return (React.createElement(ToggleContext.Consumer, null, function (_a) {
        var id = _a.id, isOn = _a.isOn, toggleHandler = _a.toggleHandler, disabled = _a.disabled, title = _a.title;
        return (React.createElement(Switch, __assign({ isOn: isOn, id: id, onChange: toggleHandler, disabled: disabled, title: title }, props)));
    }));
}
export default ToggleButton;
